export enum ImageSizeAdjustment {
  NONE = 'NONE',
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
}
